// The chat-title contract is single-sourced in libs/shared;
// re-exported so existing module-local imports keep working.
export { NEW_CHAT_TITLE_DEFAULT } from '@shared';
export const LOADING_TIME_FOR_MESSAGE = 550;
export const RECENT_CHATS_LIMIT = 100;

export const MAX_USER_INPUT_LENGTH = 12000;
export const MAX_FILE_UPLOAD_COUNT = 5;
export const MAX_FILE_UPLOAD_COUNT_FOR_COMPARISON_TRAIT_ASSISTANT = 3;
export const MIN_FILE_UPLOAD_COUNT_FOR_COMPARISON_TRAIT_ASSISTANT = 2;
export const MAX_FILE_UPLOAD_COUNT_FOR_EXTRACT_TRAIT_ASSISTANT = 100;
export const MIN_FILE_UPLOAD_COUNT_FOR_EXTRACT_TRAIT_ASSISTANT = 1;
export const MAX_FILE_UPLOAD_COUNT_FOR_COMPLIANCE_TRAIT_ASSISTANT_REFERENCE = 10;
export const MAX_FILE_UPLOAD_COUNT_FOR_COMPLIANCE_TRAIT_ASSISTANT_REGULAR = 1;
export const MIN_FILE_UPLOAD_COUNT_FOR_COMPLIANCE_TRAIT_ASSISTANT = 1;
